import gql from 'graphql-tag'

export const listingFields = gql`
  query ListingFields($entityId: Int!, $token: String, $userId: Int) {
    listingFields(entityId: $entityId, token: $token, userId: $userId) {
      searchFields
      displayFields
    }
  }
`
